export default __webpack_public_path__ + "static/media/Class-10-CBSE-Hindi.dc0e84b2.pdf";